import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import WelcomeImage from '../../Components/ImagesWithElements/WelcomeImage';
import PasswordInput from '../../Components/PasswordInput';
import usePortalService from '../../services/PortalService';
import { Spin } from 'antd';

type LoginWithCodeProps = {
    setToken: (token: string) => void;
    setRole: (role: string) => void;
}
 
export default function LoginWithCode({ setToken, setRole } : LoginWithCodeProps) {
    const { loginWithCode, createLoginCode, getAvatar, getCompanyImage } = usePortalService();
    const navigate = useNavigate();

    const regEmail = /[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+/;
    const [email, setEmail] = useState('');
    const [emailDirty, setEmailDirty] = useState(false);
    const [emailError, setEmailError] = useState('Некорректный email');

    const [code, setCode] = useState('');
    const [codeDirty, setCodeDirty] = useState(false);
    const [codeError, setCodeError] = useState('Введите код');

    const [isSended, setIsSended] = useState(false);
    const [authError, setAuthError] = useState('');
    const [isUploading, setIsUploading] = useState(false);

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'email':
                setEmailDirty(true)
                break;
            case 'code':
                setCodeDirty(true)
                break;
        }
    }

    const emailHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
        if (!regEmail.test(String(e.target.value).toLowerCase())) {
            setEmailError('Некорректный email')
        } else {
            setEmailError('')
        }
    }

    const codeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value)
        if (e.target.value.length != 6) {
            setCodeError('Код должен состоять из 6 цифр')
        } else {
            setCodeError('')
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (emailError) {
            setEmailDirty(true)
        }
        else if (!isSended) {
            const result = await createLoginCode({
                login: email
            });
            if (result.success) {
                setIsSended(true)
            } else {
                setAuthError(result.errors)
            }
        } else {
            if (codeError) {
                setCodeDirty(true)
            } else {
                setIsUploading(true)
                setAuthError('')
                const result = await loginWithCode({
                    login: email,
                    code
                });
        
                if (result.success) {
                    setToken(result.token);
                    setRole(result.role);
                    if (result.iconProfile) {
                        let icon;
                        if (result.role === "manager") {
                            icon = await getCompanyImage(result.iconProfile)
                        } else {
                            icon = await getAvatar(result.iconProfile)
                        }
                        localStorage.setItem('iconProfile', icon);
                    }
                    if (result.isRedirectToMainPage) {
                        navigate('/');
                        navigate(0);
                    } else {
                        const tours = []
                        if (result.role === "manager") {
                            tours.push('homeEmployer', 'vacancyEditor', 'candidates')
                        }
                        else if (result.role === "profile") {
                            tours.push('vacancies', 'vacancy')
                        }
                        localStorage.setItem('incompleteTours', JSON.stringify(tours));
                        navigate('/fillProfile1');
                        navigate(0);
                    }
                } else {
                    setIsUploading(false)
                    setAuthError(result.errors)
                }
            }
        }
    }

    return (
        <>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <WelcomeImage/>
                </section>
                <div className="content" >
                    <div className="auth-content">
                        <h1 style={{ marginBottom: '32px' }}> Войти в РТСИМ.Карьера </h1>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="form-group" controlId="formEmail">
                                <Form.Label> Email </Form.Label>
                                <Form.Control 
                                    type="email" 
                                    placeholder="" 
                                    name='email'
                                    value={email} 
                                    onBlur={blurHandler}
                                    onChange={emailHandler}
                                    isInvalid={!!(emailDirty && emailError)} 
                                />
                                {(emailDirty && emailError) && <p className="error-alert">{emailError}</p>}
                            </Form.Group>
                            {
                                (isSended) && 
                                <Form.Group className="form-group" controlId="formPassword">
                                    <Form.Label> Код из письма </Form.Label>
                                    <Form.Control
                                        value={code} 
                                        onChange={codeHandler} 
                                        onBlur={blurHandler} 
                                        name="code"
                                        isInvalid={!!(codeDirty && codeError)}
                                    />
                                    {(codeDirty && codeError) && <p className="error-alert">{codeError}</p>}
                                </Form.Group>
                            }
                            <br />
                            {(isUploading) ? 
                                <Spin tip="Загрузка">
                                    <div className="content" />
                                </Spin> :
                                <Button variant="primary" type="submit" style={{width: '173px', height: '40px'}}> {(isSended) ? "Войти" : "Отправить код"} </Button>
                            }
                            <p className="error-alert">{authError}</p>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};